import { render, staticRenderFns } from "./DelegateMonitor.vue?vue&type=template&id=06ee7990&"
import script from "./DelegateMonitor.vue?vue&type=script&lang=ts&"
export * from "./DelegateMonitor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports